import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const UpdateSYC = gql`
  mutation UpdateSYC($input: UpdateSYCInput!) {
    updateSYC(input: $input) {
      __typename
      ... on UpdateSYCSuccess {
        key
        isFirstTime
        successTitle: title
        successMessage: message
        syc {
          id
          enabled
        }
      }
      ... on UpdateSYCError {
        ...error
      }
    }
  }
  ${error}
`;
